<template>
  <a-modal
    :visible="visible"
    title="支付预售尾款"
    @cancel="handleCancel"
    :maskClosable="false"
    :confirmLoading="submitLoading"
    :okText="'确认收款'"
    @ok="handleSubmit"
  >
    <a-spin :spinning="detailLoading">
      <a-descriptions :column="1" bordered size="small" style="margin-bottom: 16px;">
        <a-descriptions-item label="订单编号">{{ order.id || '-' }}</a-descriptions-item>
        <a-descriptions-item label="买家名称">{{ order.buyerName || '游客' }}</a-descriptions-item>
        <a-descriptions-item label="订单金额">¥{{ money(order.orderAmount) }}</a-descriptions-item>
        <a-descriptions-item label="订单实收（定金）">¥{{ money(order.preDepositAmount) }}</a-descriptions-item>
        <a-descriptions-item label="待付尾款">
          <span style="color: #ff4d4f; font-weight: 600;">¥{{ money(finalAmount) }}</span>
          <span style="margin-left: 8px; color: #999;">尾款一次性付清</span>
        </a-descriptions-item>
      </a-descriptions>

      <div style="margin-bottom: 8px; color: #666;">支付方式</div>
      <a-radio-group v-model="form.payMethod" class="payment-grid">
        <div
          v-for="(item, index) in payTypes"
          :key="index"
          :class="['payment-option', { selected: form.payMethod === item.value, disabled: isDisabled(item) }]"
          @click="!isDisabled(item) ? form.payMethod = item.value : null"
        >
          <a-radio :value="item.value" class="payment-radio" :disabled="isDisabled(item)">
            <a-icon :type="item.icon" :style="{ color: item.color, fontSize: '18px', marginRight: '6px' }" />
            <span class="payment-label">{{ item.label }}</span>
          </a-radio>
        </div>
      </a-radio-group>

      <a-form-model v-if="form.payMethod === 2" :model="form" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
        <a-form-model-item label="微信付款码">
          <a-input v-model="form.authCode" placeholder="请输入微信付款码" :maxLength="30" />
        </a-form-model-item>
      </a-form-model>

      <a-alert
        v-if="form.payMethod === 1"
        type="warning"
        showIcon
        message="暂不支持支付宝，请改用其他支付方式"
      />
      <a-alert
        v-else-if="form.payMethod === 6 && !hasMember"
        type="warning"
        showIcon
        message="该订单没有绑定会员，无法使用余额支付"
      />
      <a-alert
        v-else
        type="info"
        showIcon
        message="预售尾款一次性付清，付清后订单状态自动流转（线上单转待发货，收银台单转已完成）"
      />
    </a-spin>
  </a-modal>
</template>

<script>
import { payCashierFinal, getCashierOrderDetail } from '@/api/retail/order'

export default {
  name: 'PayFinalModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // 订单行数据(列表)
    orderData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      submitLoading: false,
      detailLoading: false,
      // 订单详情(尾款金额以此为准)
      order: {},
      // 支付方式,与收银台保持一致
      payTypes: [
        { label: '微信支付', value: 2, icon: 'wechat', color: '#09bb07' },
        { label: '支付宝', value: 1, icon: 'alipay', color: '#1677ff' },
        { label: '现金', value: 10, icon: 'wallet', color: '#52c41a' },
        { label: '余额支付', value: 6, icon: 'account-book', color: '#faad14', requireMember: true },
        { label: '人民币支票', value: 11, icon: 'file-text', color: '#722ed1' },
        { label: '人民币信用卡', value: 12, icon: 'credit-card', color: '#eb2f96' }
      ],
      form: {
        payMethod: 10,
        authCode: ''
      }
    }
  },
  computed: {
    // 待付尾款金额(取订单尾款金额,一次性付清)
    finalAmount() {
      return Number(this.order.preEndAmount || 0)
    },
    // 是否有绑定会员(余额支付需要)
    hasMember() {
      return !!(this.order.buyerId && Number(this.order.buyerId) !== 0)
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.form.payMethod = 10
        this.form.authCode = ''
        this.loadOrderDetail()
      }
    }
  },
  methods: {
    // 金额格式化
    money(val) {
      return Number(val || 0).toFixed(2)
    },
    // 支付方式是否不可选
    isDisabled(item) {
      return item.requireMember && !this.hasMember
    },
    // 加载订单详情(尾款金额以订单表数据为准)
    loadOrderDetail() {
      this.detailLoading = true
      this.order = { ...(this.orderData || {}) }
      if (!this.orderData || !this.orderData.id) {
        this.detailLoading = false
        return
      }
      getCashierOrderDetail(this.orderData.id).then(res => {
        if (res.data) {
          this.order = { ...this.order, ...res.data }
        }
      }).catch(() => {
      }).finally(() => {
        this.detailLoading = false
      })
    },
    handleCancel() {
      this.$emit('cancel')
    },
    handleSubmit() {
      if (!this.order.id) {
        this.$message.warning('订单信息加载失败，请关闭后重试')
        return
      }
      if (this.finalAmount <= 0) {
        this.$message.warning('未获取到尾款金额，请关闭后重试')
        return
      }
      if (this.form.payMethod === 2 && !this.form.authCode) {
        this.$message.warning('请输入微信付款码')
        return
      }
      this.submitLoading = true
      payCashierFinal({
        orderId: this.order.id,
        payMethod: this.form.payMethod,
        authCode: this.form.authCode
      }).then(res => {
        this.submitLoading = false
        if (res.code == 20001) {
          this.$message.success('尾款支付成功')
          this.$emit('success')
        } else {
          this.$message.error(res.msg || '尾款支付失败')
        }
      }).catch(() => {
        this.submitLoading = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
.payment-grid {
  display: flex;
  flex-wrap: wrap;
}

.payment-option {
  width: 33.33%;
  padding: 8px 12px;
  margin-bottom: 8px;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
}

.payment-option.selected {
  border-color: #1890ff;
  background: #f0f9ff;
}

.payment-option.disabled {
  cursor: not-allowed;
  opacity: 0.45;
}
</style>
